import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Transition as _Transition } from "vue"
import _imports_0 from '@/assets/logo.png'


const _hoisted_1 = { class: "sticky top-0 z-50" }
const _hoisted_2 = {
  key: 0,
  class: "bg-secondary text-primary"
}
const _hoisted_3 = { class: "max-w-page mx-auto px-6 py-2.5 flex items-center justify-center gap-x-4 relative" }
const _hoisted_4 = { class: "text-sm font-medium text-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "→", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-4 h-4",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M6 18L18 6M6 6l12 12"
  })
], -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "max-w-page mx-auto px-6 h-16 md:h-[72px] flex items-center justify-between gap-6" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  class: "block h-7 md:h-8 w-auto",
  src: _imports_0,
  alt: "Bloqin"
}, null, -1)
const _hoisted_10 = { class: "hidden lg:flex items-center gap-1 text-sm font-medium text-primary" }
const _hoisted_11 = { class: "flex items-center gap-2" }
const _hoisted_12 = {
  class: "relative hidden md:block",
  ref: "langMenuRef"
}
const _hoisted_13 = ["aria-expanded"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-4 h-4",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M12 21a9 9 0 100-18 9 9 0 000 18z"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    d: "M3.6 9h16.8M3.6 15h16.8M12 3a13.5 13.5 0 010 18M12 3a13.5 13.5 0 000 18"
  })
], -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = {
  key: 0,
  class: "absolute right-0 mt-2 w-44 rounded-card bg-cream border border-stone p-1 z-50",
  role: "menu"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  role: "menuitem",
  class: "w-full flex items-center justify-between gap-2 px-3 py-2 rounded-btn bg-parchment text-primary text-sm font-medium"
}, [
  /*#__PURE__*/_createElementVNode("span", null, "Türkçe"),
  /*#__PURE__*/_createElementVNode("svg", {
    class: "w-4 h-4 text-secondary",
    fill: "none",
    stroke: "currentColor",
    "stroke-width": "2.5",
    viewBox: "0 0 24 24"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M5 13l4 4L19 7"
    })
  ])
], -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  role: "menuitem",
  disabled: "",
  class: "w-full flex items-center justify-between gap-2 px-3 py-2 rounded-btn text-graphite text-sm cursor-not-allowed"
}, [
  /*#__PURE__*/_createElementVNode("span", null, "English"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-xs tracking-label uppercase" }, "Yakında")
], -1)
const _hoisted_19 = [
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = {
  key: 0,
  class: "w-5 h-5",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  viewBox: "0 0 24 24"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "M4 6h16M4 12h16M4 18h16"
}, null, -1)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = {
  key: 1,
  class: "w-5 h-5",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  viewBox: "0 0 24 24"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  d: "M6 18L18 6M6 6l12 12"
}, null, -1)
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = {
  key: 0,
  class: "lg:hidden border-t border-stone bg-cream"
}
const _hoisted_27 = { class: "max-w-page mx-auto px-6 py-4 flex flex-col gap-1 text-base font-medium text-primary" }
const _hoisted_28 = { class: "pt-2 mt-2 border-t border-stone" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    (_ctx.bannerOpen)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("p", _hoisted_4, [
              _createTextVNode(" 10.000 TL'den başlayan tokenize gayrimenkul yatırımı yakında. "),
              _createVNode(_component_router_link, {
                to: "/#waitlist",
                class: "underline font-semibold ml-2"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Erken erişime kayıt ol "),
                  _hoisted_5
                ]),
                _: 1
              })
            ]),
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.dismissBanner && _ctx.dismissBanner(...args))),
              "aria-label": "Kapat",
              class: "absolute right-4 top-1/2 -translate-y-1/2 w-6 h-6 flex items-center justify-center text-primary hover:opacity-70"
            }, _hoisted_7)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("nav", {
      class: _normalizeClass(["border-b border-stone backdrop-blur transition-colors", _ctx.scrolled ? 'bg-cream/90' : 'bg-cream'])
    }, [
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_router_link, {
          to: "/",
          class: "flex items-center shrink-0 h-full"
        }, {
          default: _withCtx(() => [
            _hoisted_9
          ]),
          _: 1
        }),
        _createElementVNode("ul", _hoisted_10, [
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              to: "/#features",
              class: "px-3 py-2 rounded-btn hover:bg-parchment transition-colors"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Yatırımlar ")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              to: "/#how",
              class: "px-3 py-2 rounded-btn hover:bg-parchment transition-colors"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Nasıl Çalışır ")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              to: "/#roadmap",
              class: "px-3 py-2 rounded-btn hover:bg-parchment transition-colors"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Yol Haritası ")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              to: "/about",
              class: "px-3 py-2 rounded-btn hover:bg-parchment transition-colors"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Hakkımızda ")
              ]),
              _: 1
            })
          ]),
          _createElementVNode("li", null, [
            _createVNode(_component_router_link, {
              to: "/apply",
              class: "px-3 py-2 rounded-btn hover:bg-parchment transition-colors"
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Birlikte Çalışalım ")
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.langOpen = !_ctx.langOpen)),
              "aria-label": "Dil seçimi",
              "aria-expanded": _ctx.langOpen,
              class: _normalizeClass(["w-10 h-10 rounded-full border border-stone flex items-center justify-center text-primary hover:bg-parchment transition-colors", _ctx.langOpen ? 'bg-parchment' : ''])
            }, _hoisted_15, 10, _hoisted_13),
            _createVNode(_Transition, {
              "enter-active-class": "transition ease-out duration-150",
              "enter-from-class": "opacity-0 translate-y-1",
              "enter-to-class": "opacity-100 translate-y-0",
              "leave-active-class": "transition ease-in duration-100",
              "leave-from-class": "opacity-100",
              "leave-to-class": "opacity-0"
            }, {
              default: _withCtx(() => [
                (_ctx.langOpen)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, _hoisted_19))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ], 512),
          _createVNode(_component_router_link, {
            to: "/login",
            class: "hidden sm:inline-flex items-center px-4 py-2.5 rounded-btn border border-primary text-primary text-sm font-medium hover:bg-primary hover:text-cream transition-colors"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Yatırımcı Paneli ")
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/#waitlist",
            class: "inline-flex items-center px-4 py-2.5 rounded-btn border border-primary bg-secondary text-primary text-sm font-medium hover:bg-primary hover:text-secondary transition-colors"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Bekleme Listesi ")
            ]),
            _: 1
          }),
          _createElementVNode("button", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.mobileOpen = !_ctx.mobileOpen)),
            "aria-label": "Menü",
            class: "lg:hidden w-10 h-10 rounded-full border border-stone flex items-center justify-center text-primary hover:bg-parchment transition-colors"
          }, [
            (!_ctx.mobileOpen)
              ? (_openBlock(), _createElementBlock("svg", _hoisted_20, _hoisted_22))
              : (_openBlock(), _createElementBlock("svg", _hoisted_23, _hoisted_25))
          ])
        ])
      ]),
      (_ctx.mobileOpen)
        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
            _createElementVNode("ul", _hoisted_27, [
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, {
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.mobileOpen = false)),
                  to: "/#features",
                  class: "block px-3 py-3 rounded-btn hover:bg-parchment"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Yatırımlar")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, {
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.mobileOpen = false)),
                  to: "/#how",
                  class: "block px-3 py-3 rounded-btn hover:bg-parchment"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Nasıl Çalışır")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, {
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.mobileOpen = false)),
                  to: "/#roadmap",
                  class: "block px-3 py-3 rounded-btn hover:bg-parchment"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Yol Haritası")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, {
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.mobileOpen = false)),
                  to: "/about",
                  class: "block px-3 py-3 rounded-btn hover:bg-parchment"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Hakkımızda")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", null, [
                _createVNode(_component_router_link, {
                  onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.mobileOpen = false)),
                  to: "/apply",
                  class: "block px-3 py-3 rounded-btn hover:bg-parchment"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Birlikte Çalışalım")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("li", _hoisted_28, [
                _createVNode(_component_router_link, {
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.mobileOpen = false)),
                  to: "/login",
                  class: "block px-3 py-3 rounded-btn hover:bg-parchment"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Yatırımcı Paneli")
                  ]),
                  _: 1
                })
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}